// extracted by mini-css-extract-plugin
export default {"agentMetricTagCtn":"agentMetricTag_agentMetricTagCtn__LDa5G","agentMetricTagText":"agentMetricTag_agentMetricTagText__gpLnr"};